import { render, staticRenderFns } from "./MessageStatusIcon.vue?vue&type=template&id=4c43085b&scoped=true&"
import script from "./MessageStatusIcon.vue?vue&type=script&lang=js&"
export * from "./MessageStatusIcon.vue?vue&type=script&lang=js&"
import style0 from "./MessageStatusIcon.vue?vue&type=style&index=0&id=4c43085b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c43085b",
  null
  
)

export default component.exports